export default __webpack_public_path__ + "static/media/taroble-cards.fddee15d.jpg";